import { Container, styled } from '@material-ui/core';

export const TermsThemeContainer = styled(Container)(({ theme }) => ({
  '& .MuiTypography-h1': {
    color: '333333',
    textAlign: 'center',
    '&:after': {
      content: '""',
      display: 'block',
      height: '6px',
      width: '184px',
      margin: theme.spacing(3, 'auto', 0),
      background:
        'transparent linear-gradient(90deg, #6A8AFF 0%, #6AA4FF 100%) 0% 0% no-repeat padding-box',
    },
  },
  '& .MuiTypography-h2': {
    color: '#4E7FF2',
    marginTop: theme.spacing(7),
  },
  '& .MuiTypography-h3': {
    color: '#4E7FF2',
    marginTop: theme.spacing(7),
  },
  '& .MuiTypography-h4': {
    marginTop: theme.spacing(7),
  },
  '& .MuiTypography-h5': {
    marginTop: theme.spacing(7),
  },
  '& .MuiTypography-h6': {
    marginTop: theme.spacing(7),
  },
  '& .MuiTypography-body1': {
    paddingTop: theme.spacing(2),
  },
  '& .MuiTypography-body2': {
    paddingTop: theme.spacing(2),
  },
  '& .MuiLink-root': { color: '#1565c0' },
  '& .MuiList-root': {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0),
    '& .MuiListItem-root': {
      marginBottom: theme.spacing(1),
      '&:last-child': {
        marginBottom: theme.spacing(0),
      },
      '& .MuiTypography-body1': {
        margin: 0,
        padding: 0,
      },
    },
    '& ol.MuiList-root': {
      counterReset: 'item',
      listStyleType: 'none',
      margin: theme.spacing(-0.25, 0, 2, 3.5),
      padding: 0,
      '& .MuiListItem-root': {
        position: 'static',
        marginTop: theme.spacing(-2.25),
        '&:first-child': { marginTop: 0 },
        '&::before': {
          counterIncrement: 'item',
          content: '"(" counter(item) ") "',
          position: 'relative',
          top: '18px',
          left: '-36px',
          fontSize: '14px',
          lineSpacing: '21px',
        },
      },
    },
    '& ul.MuiList-root': {
      listStyle: 'circle',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      '& .MuiListItem-root': {
        marginTop: theme.spacing(1),
        '& .MuiTypography-body1': {
          padding: 0,
        },
      },
    },
  },
  '& ol.MuiList-root': { listStyle: 'decimal' },
  '& ul.MuiList-root': { listStyle: 'disc' },
  '& .MuiList-padding': { padding: theme.spacing(0, 0, 0, 4) },
  '& .MuiListItem-root': {
    display: 'list-item',
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: theme.spacing(1),
    '&:first-child': { marginTop: 0 },
  },
  '& .MuiListItem-gutters': {
    paddingRight: 0,
    paddingLeft: theme.spacing(2),
  },
  '& .MuiListItemText-root': { margin: 0 },

  '& .MuiTable-root': {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(9),
  },
  '& .MuiTableCell-root': {
    padding: theme.spacing(1.5, 1),
    borderBottom: '1px solid #7F7F7F',
    verticalAlign: 'top',
    color: '#333333',
    fontSize: '14px',
    lineHeight: '21px',
    minWidth: theme.spacing(20),
    maxWidth: theme.spacing(30),
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    color: '#7F7F7F',
    fontWeight: 'bold',
  },
  '& .MuiTableCell-root:first-child': {
    paddingLeft: theme.spacing(2),
    fontWeight: 'bold',
  },
  '& .MuiTableCell-root:last-child': { paddingRight: theme.spacing(2) },
  '& .MuiTableRow-root:last-child > .MuiTableCell-root': {
    borderBottom: '2px solid #7F7F7F',
  },

  '& > *:first-child': { marginTop: 0 },
}));
